var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcWhitePlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#E5ECFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.195 38.436 36.583 26.359a2.003 2.003 0 0 0-3.181 1.616V52.12a1.997 1.997 0 0 0 3.181 1.613l16.612-12.066c.524-.386.83-.982.83-1.616a1.989 1.989 0 0 0-.83-1.616z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.001 0C17.906 0 0 17.908 0 40.007 0 62.097 17.906 80 40.001 80 62.091 80 80 62.095 80 40.007 80.003 17.907 62.092 0 40.001 0zm0 73.325c-18.4 0-33.319-14.913-33.319-33.318 0-18.398 14.919-33.33 33.32-33.33 18.397 0 33.313 14.93 33.313 33.33.003 18.405-14.916 33.318-33.314 33.318z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWhitePlay);
export default __webpack_public_path__ + "static/media/ic_white_play.44aad7c45569604b8f70b67ece703919.svg";
export { ForwardRef as ReactComponent };